import React from "react";
import styled from "styled-components";
import { Flex, Button } from "../../components";

const ModalWrapper = styled(Flex)`
  display: ${({ open }) => (open ? "display" : "none")};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
`;

const ModalTextWrapper = styled(Flex)`
  width: 25vw;
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: .5em;
  background: #fff;
  @media(max-width:767px){
    width:300px !important;
  }
`;

const Modal = ({ open, handleModalToggle, handleSubmit,dialogTitle }) => (
  
  <ModalWrapper center open={open}>
    <ModalTextWrapper column>
      <p style={{fontSize:'14px',fontWeight:'bold',marginBottom:'20px'}} >{dialogTitle}</p>
      <Flex justifyBetween>
        <Button onClick={handleModalToggle}>No</Button>
        <Button onClick={handleSubmit}>Yes</Button>
      </Flex>
    </ModalTextWrapper>
  </ModalWrapper>
);

export default Modal;
